/** contentData 등 stepCode가 있는 컨텐츠 배열에서 stepCode별 파일 목록 (contentOrder 오름차순) */
export const getStepContents = (contents, stepCode) =>
  (contents ?? [])
    .filter((c) => c.stepCode === stepCode)
    .sort((a, b) => Number(a.contentOrder) - Number(b.contentOrder));

/** stepCode별 curContentOrder에 해당하는 탭 인덱스 */
export const getContentIndexByCurOrder = (contents, stepCode) => {
  const stepContents = getStepContents(contents, stepCode);
  if (!stepContents.length) return 0;

  const curContentOrder =
    stepContents.find((c) => c.curContentOrder != null)?.curContentOrder ??
    stepContents[0]?.contentOrder ??
    1;

  const index = stepContents.findIndex(
    (c) => Number(c.contentOrder) === Number(curContentOrder)
  );
  return index >= 0 ? index : 0;
};

export const buildDocumentFileUrl = (path, baseUrl) => {
  if (!path) return '';
  const ext = path.split('.').pop()?.toLowerCase();
  let finalPath = path;
  if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
    finalPath = path.replace(/\.[^/.]+$/, '.pdf');
  }
  return `${baseUrl}files/${finalPath}`;
};
